import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
  lastNameColumn,
  firstNameColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA, setDateFilterDefs } from "../../../../../utils/commonFunctions";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
import { fetchRolesList } from "../../../../../store/CommonSlice";
import { dateFormatter } from "../../../../../config/Global";
import { dateFormats } from "../../utils/constats";



const useColumnDefs = () => {
  const dispatch = useAppDispatch();


  const emailColumn: ColDef = generateColumn("", "email");

  const mobileNumberColumn: ColDef = generateColumn("Mobile Number", "mobile_no");

  const roleColumn: ColDef = {
    field: "role",
    headerName: "Role",
    cellRenderer: (props: any) => {
      return renderNA(props.data.role);
    },
    filter: "agSetColumnFilter",
    filterParams: {
      values: (params: any) => {
        dispatch(fetchRolesList()).then((data: any) => {
          params.success(data?.data?.map((role: any) => role?.name));
        });
      },
      buttons: ["apply", "reset"],
      closeOnApply: true,
    },
  };


  const companyColumn: ColDef = generateColumn("", "company_name");

  const campaignColumn: ColDef = generateColumn("Subscription Name", "campaign_name");


  const dobColumn: ColDef = {
    field: "dob",
    headerName: "Date Of Birth",
    cellRenderer: (props: any) => {
      return props.data.dob
        ? dateFormatter(props.data.dob, dateFormats.dob)
        : "N/A";
    },
    filterValueGetter: (props: any) => {
      return props.data.dob
        ? dateFormatter(props.data.dob, dateFormats.dob)
        : "N/A";
    },
    valueGetter: (props: any) => {
      return props.data.dob
        ? dateFormatter(props.data.dob, dateFormats.dob)
        : "N/A";
    },
  };

  console.log('dobColumn', dateFormatter('2011-02-08', dateFormats.dob))

  const genderColumn: ColDef = generateColumn("", "gender");
  const houseHoldColumn: ColDef = generateColumn("", "household_income");

  const ethnicityColumn: ColDef = generateColumn("", "ethnicity");


  const disabilityStatusColumn: ColDef = generateColumn("Disability Status", "disabilities");
  const veteranStatusColumn: ColDef = generateColumn("Military Status", "veteran");
  const locationColumn: ColDef = generateColumn("", "location");
  const examStatusDisplayColumn: ColDef = generateColumn("Exam Status", "exam_status_display");
  const UserTypeColumn: ColDef = generateColumn("User Type", "purchased");
  const SubscriptinStatus: ColDef = generateColumn("Subscription Status", "subscribed");


  const lastLoginDateColumn: ColDef = {
    ...{
      field: "data.last_login",
      headerName: "Last Login Date",
      cellRenderer: (props: any) => {
        return props.data.last_login
          ? dateFormatter(props.data.last_login, dateFormats.dateFormat)
          : "N/A";
      },
      filterValueGetter: (props: any) => {
        return props.data.last_login
          ? dateFormatter(props.data.last_login, dateFormats.dateFormat)
          : "N/A";
      },
      valueGetter: (props: any) => {
        return props.data.last_login
          ? dateFormatter(props.data.last_login, dateFormats.dateFormat)
          : "N/A";
      },
    },
    ...setDateFilterDefs()
  };
  const lastLoginTimeColumn: ColDef = {
    ...{
      field: "data.last_login",
      headerName: "Last Login Time",
      cellRenderer: (props: any) => {
        return props.data.last_login
          ? dateFormatter(props.data.last_login, dateFormats.timeFormat)
          : "N/A";
      },
      filterValueGetter: (props: any) => {
        return props.data.last_login
          ? dateFormatter(props.data.last_login, dateFormats.timeFormat)
          : "N/A";
      },
      valueGetter: (props: any) => {
        return props.data.last_login
          ? dateFormatter(props.data.last_login, dateFormats.timeFormat)
          : "N/A";
      },
    },
  };

  return [
    idColumn,
    firstNameColumn,
    lastNameColumn,
    emailColumn,
    mobileNumberColumn,
    UserTypeColumn,
    companyColumn,
    campaignColumn,
    SubscriptinStatus,
    roleColumn,
    { ...dobColumn, ...setDateFilterDefs() },
    genderColumn,
    ethnicityColumn,
    disabilityStatusColumn,
    veteranStatusColumn,
    locationColumn,
    houseHoldColumn,
    lastLoginDateColumn,
    lastLoginTimeColumn,
    examStatusDisplayColumn,
    statusColumn,
    { ...actionColumn, width: 230, minWidth: 230 },
  ];
};
export default useColumnDefs;